export default function (Component) {
  Component.__i18n = Component.__i18n || []
  Component.__i18n.push({
    "locale": "",
    "resource": {
      "en": {
        "SELECT_DATE": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Select date"])},
        "DATE_VALIDATION": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Date is required"])}
      }
    }
  })
}
